import axios from 'axios'

//http request拦截器
axios.interceptors.request.use(config=>{
  return config;
},
err=>{
  return Promise.reject(err)
})
//http response拦截器
axios.interceptors.response.use(response=>{
  return response
},
error=>{
  return Promise.reject(error.response.data)
})
const Plugin={
  install(vue,options){
    vue.prototype.$getInterface=function(url,type,data,headers){
      let configHeaders={
        'Accept':'application/json',
        'Content-type':'application/x-www-form-urlencoded;charset=UTF-8'
      }
      //添加token
      // configHeaders=Object.assign({
      //   'token':'',
      //   'urlHref':''
      // },configHeaders)
      let httpDefaultOpts={
        method:type,
        url:url,
        headers:configHeaders,
        timeout:20000,//超时时间
        //params:Object.assign(Public,data),
        data:data,
        transformRequest:function(data){
          let ret = ''
          for (let it in data) {
            ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
          }
          return ret
        },
        transformResponse:function(data){
          data=JSON.stringify(data);
          return data;
        }
      }
      // if(type='GET'){
      //   delete httpDefaultOpts.data
      // }else{
      //   delete httpDefaultOpts.params
      // }
      let promise=new Promise(function(resolve,reject){
        axios(httpDefaultOpts).then((res)=>{
          resolve(res)
        }).catch((response)=>{
          reject(response)
        })
      })
      return promise
    }
  }
}
export default Plugin
